import { render, staticRenderFns } from "./Bottommenu.vue?vue&type=template&id=6fb98ec2&scoped=true"
import script from "./Bottommenu.vue?vue&type=script&lang=js"
export * from "./Bottommenu.vue?vue&type=script&lang=js"
import style0 from "./Bottommenu.vue?vue&type=style&index=0&id=6fb98ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb98ec2",
  null
  
)

export default component.exports